var React = require('react');

function IconArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m6 8 4-4v8L6 8z","fill":"#fff"}));
}

IconArrowLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconArrowLeft;

IconArrowLeft.default = IconArrowLeft;
